import React from 'react';
import { createRoot } from 'react-dom/client';
import AllDistExports, { JoyDoc, JoyDocExporter } from './index';

function mountComponent(Component, element, props) {
  const root = createRoot(element);
  const update = (nextProps) => root.render(React.createElement(Component, nextProps));
  update(props);

  return {
    update,
    unmount: () => root.unmount()
  };
}

function JoyDocBrowser(element, props) {
  return mountComponent(JoyDoc, element, props);
}

function JoyDocExporterBrowser(element, props) {
  return mountComponent(JoyDocExporter, element, props);
}

export default {
  ...AllDistExports,
  JoyDoc: JoyDocBrowser,
  JoyDocExporter: JoyDocExporterBrowser
};
